// ---------------------------------
// client/src/pages/Signup.jsx
// User registration page
// ---------------------------------
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const TEXT = {
    title: 'הרשמה',
    name: 'שם מלא',
    email: 'כתובת אימייל',
    submit: 'צור חשבון',
    success: 'ההרשמה הושלמה, החשבון ממתין לאישור מנהל.',
    error: 'לא ניתן להשלים את ההרשמה.',
    loginHint: 'כבר רשום אצלנו?',
    loginAction: 'כניסה',
};

export default function Signup() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccess('');
        try {
            await api.post('/auth/register', { name, email });
            setSuccess(TEXT.success);
            setTimeout(() => navigate('/login', { replace: true }), 1500);
        } catch (err) {
            setError(err.response?.data?.message || TEXT.error);
        }
    };

    return (
        <div className="page page--auth page--accent stack stack--lg">
            <header className="page__header">
                <h1 className="page__title">{TEXT.title}</h1>
            </header>
            <section className="form-card">
                <form className="stack" onSubmit={handleSubmit}>
                    <label className="form-field">
                        <span className="form-field__label">{TEXT.name}</span>
                        <input
                            className="form-field__control"
                            type="text"
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            required
                        />
                    </label>
                    <label className="form-field">
                        <span className="form-field__label">{TEXT.email}</span>
                        <input
                            className="form-field__control"
                            type="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            required
                        />
                    </label>
                    {error && <div className="alert alert--danger">{error}</div>}
                    {success && <div className="alert alert--success">{success}</div>}
                    <button type="submit" className="button button--primary">
                        {TEXT.submit}
                    </button>
                </form>
            </section>
            <div className="flex">
                <span>{TEXT.loginHint}</span>
                <button type="button" className="button button--ghost" onClick={() => navigate('/login')}>
                    {TEXT.loginAction}
                </button>
            </div>
        </div>
    );
}
